import LanguageForm from "../../components/Language/LanguageForm";
import { initValues } from "../../utils/LanguageObjectEmpty";

export default function LanguageEdit() {
  return <LanguageForm language={initValues} isNew={true} />;
}
